import CalendarComponent from 'src/components/calendars';
import { RouteComponentProps } from 'react-router';
import React, { FC, useEffect, useState } from 'react';
import AdminLayout from 'src/components/layout/RoleLayout';
import Breadcrumbs from 'src/components/Breadcrumbs';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from './assets/calendar-screen.module.scss';

import { ICase } from 'src/types/case';
import { IProvider } from 'src/types/provider';
import { ISeance } from 'src/types/seance';
import { QueryMultiParams, QueryParams } from 'src/types/grid';
import { changeToZeroZoneDate } from 'src/helpers/timeHelpers';
import { Paginated } from 'src/services/api-handlers/pagination';
import { DropdownList } from 'react-widgets';
import Router from '../../../../navigation/router';
import moment from 'moment';
import LegendComponent from '../../../../components/calendars/LegendComponent';
import Loader from '../../../../components/Loader';

export interface StateProps {
    inProgress: boolean;
    caseEnt: ICase | null;
    provider: IProvider | null;
    seances: Paginated<ISeance>;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getCaseData: (id: string | number) => void;
    getData: (params: QueryMultiParams) => void;
    getProviders: (params: QueryParams) => void;
    updateCaseAction: (data: AnyObject) => void;
}

interface RouteParams {
    id: number;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export type OwnProps = RouteComponentProps<RouteParams>;

export interface Props extends StateProps, DispatchProps, OwnProps {}

const CalendarScreen: FC<Props> = (props: Props) => {
    // const myEventsList: any = [];

    const [date, setDate] = useState<Date | null>(changeToZeroZoneDate(''));
    const [calendar, setCalendar] = useState<boolean>(false);
    const [providerState, setProvider] = useState<{ label: string; value: string | number } | undefined>(undefined);
    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string }>({
        monthStart: moment().startOf('month').format(),
        monthEnd: moment().endOf('month').format(),
    });
    const {
        match: {
            params: { id },
        },
        history,
        caseEnt,
        providers,
        inProgress,
        getProviders,
        getData,
        seances,
        getCaseData,
    } = props;

    useEffect(() => {
        getProviders({
            page: 1,
            itemsPerPage: 1200,
        });

        if (id) {
            const prov = providers.list.find((prov: Partial<IProvider>) => `${id}` === `${prov.id}`);
            if (prov) {
                setProvider({ label: prov?.fullName, value: prov?.id });
            }
        }

        // eslint-disable-next-line
    }, [getCaseData, id]);
    useEffect(() => {
        if (providerState) {
            getData({
                page: 1,
                itemsPerPage: 80,
                filters: [
                    {
                        'provider.id': providerState.value,
                        'seanceDate[after]': month.monthStart,
                        'seanceDate[before]': month.monthEnd,
                    },
                ],
            });
        } else {
            getData({
                page: 1,
                itemsPerPage: 80,
                filters: [
                    {
                        'seanceDate[after]': month.monthStart,
                        'seanceDate[before]': month.monthEnd,
                    },
                ],
            });
        }
    }, [providerState, getData, month]);

    let start: any = undefined;
    let end: any = undefined;
    if (props?.caseEnt) {
        start = new Date(`${props?.caseEnt?.caseNumberValidityFrom}`).getTime() - 120 * 60 * 1000;
        end = new Date(`${props?.caseEnt?.caseNumberValidityTo}`).getTime();
    }

    const onChangeDate = (date: Date | any) => {
        const endOfDat = new Date(`${date}`);

        endOfDat.setHours(12, 59, 59, 999);
        setDate(endOfDat);
    };
    const onChangeNav = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D');
        const endOfDat = moment(date).startOf('month').toDate();

        endOfDat.setHours(23, 59, 59, 999);
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D');
        setDate(endOfDat);
        setMonth({
            monthStart,
            monthEnd,
        });
    };
    const providerValues: SelectObject[] = [];
    providers.list.forEach((prov: Partial<IProvider>) => {
        providerValues.push({ value: prov.id, label: `${prov.fullName}` });
    });
    providerValues.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    return (
        <AdminLayout>
            <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                    SESSION SCHEDULE
                </h2>
            </div>
            <div className="w-100 mt-3 mb-4 ">
                <div>Choose Provider:</div>
                <DropdownList
                    data={[{ label: 'All', value: '' }, ...providerValues]}
                    containerClassName={'w-100'}
                    textField="label"
                    valueField="value"
                    onChange={(item: SelectObject) => {
                        setProvider(item);
                        history.push(Router.generate(routes.CALENDAR, { id: `${item.value}` }));
                    }}
                    value={providerState}
                />
            </div>
            <div className={classNames(styles.calendarWrap)}>
                <div className="">
                    <div className={classNames(styles.calendarsTop)}>
                        <LegendComponent/>
                        <div className={classNames(styles.calendarMini)}>
                            {calendar ? (
                                <SimpleCalendar
                                    min={start}
                                    containerClassName={classNames(styles.absoluteCalendar)}
                                    setDate={onChangeDate}
                                    max={end}
                                    nowDate={date}
                                    navigateDate={onChangeNav}
                                    open={'date'}
                                />
                            ) : null}
                            <button className={`btn btn-info`} onClick={(e) => setCalendar(!calendar)} type={'button'}>
                                Navigate
                            </button>
                        </div>
                    </div>

                    <div className=" w-100">
                        {inProgress ? <Loader/> : null}
                        <CalendarComponent
                            caseEnt={caseEnt}
                            seances={seances}
                            nowDate={date}
                            setDate={setDate}
                            setEvent={(data) => props.updateCaseAction({ ...data, id })}
                        />
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default CalendarScreen;
